import { useGetExercisetypesQuery } from './exercisetypesApiSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { memo } from 'react'

const Exercisetype = ({ exercisetypeId, onExercisetypeChange}) => {

    const { exercisetype } = useGetExercisetypesQuery("exercisetypesList", {
        selectFromResult: ({ data }) => ({
            exercisetype: data?.entities[exercisetypeId]
        }),
    })

    if (exercisetype) {

        return (
            <tr>
                <td>
                    {exercisetype.exercisetype}
                </td>
                <td>
                    <span
                        className="text-secondary"
                        role="button"
                        onClick={() => onExercisetypeChange(exercisetypeId, exercisetype.exercisetype)}
                        data-bs-toggle="modal" data-bs-target="#modalExercisetype"
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </span>
                </td>
            </tr>
        )

    } else return null
}

const memoizedExercisetype = memo(Exercisetype)

export default memoizedExercisetype